import "../../../src/App.css";
import PetBreed from "../../components/PetBreed/PetBreed";
import AddPetBreed from "../../components/AddPetBreed/AddPetBreed";
import PetBreedList from "../../components/PetBreedList/PetBreedList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function PetBreedMaster() {
  const [petBreedDetailResponse, setPetBreedDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [selectedPetBreedID, setSelectedPetBreedID] = useState();
  const [filterCityData, setFilterCityData] = useState(false);
  const title = "Add Pet Breed";
  const heading = "Pet Breed List";
  const baseAPI = process.env.REACT_APP_API_URL;

  const GetId = (param) => {
    setSelectedPetBreedID(param);

  };

function tokenStorage(){
  const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setPetBreedDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
};


  useEffect(() => {
    tokenStorage();
  }, []);

  //console.log(petBreedDetailResponse);

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Pet Breed Master| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {openAddProfile ? <AddPetBreed tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} /> : null}
                {openProfile ? <PetBreed tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedPetBreedID={selectedPetBreedID}  /> : null}
                <PetBreedList 
                  petBreedDetailResponse={petBreedDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  setOpenAddProfile = {setOpenAddProfile}
                />
                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PetBreedMaster;
